/* eslint-disable security/detect-object-injection */
/* eslint-disable indent */
/* eslint-disable max-len */
import React, { useCallback, useEffect, useState, useContext } from "react"
import TopHeader from "../../components/TopHeader"
import { motion } from 'framer-motion'
import { Link } from "react-router-dom"
import moment from "moment"
import { useParams, useLocation, useNavigate, useSearchParams } from "react-router-dom"
import { useSelector,useDispatch } from 'react-redux'
import { useViewDeviceQuery, useDeleteDeviceMutation } from '../../features/deviceSlice'
import CustomOverLay from "../../components/CustomOverLay"
import GlobalContext from "../../components/Context/GloablContext"
import { CDN } from "../../config"
import AnimatedModel from "../../components/Animation/AnimatedModel"
import ConfirmationPrompt from "../../components/ConfirmationPrompt"
import { convertEpochToDateFormat } from "../../CommonMethods/DateConversion"
import SearchEmptyScreen from "../../components/SearchEmptyScreen"
import { handleEditMessageSent } from "../../redux/systemConfigSlice"
import HelpGuideModal from "../../components/HelpGuideModal"
import {useGetHelpGuideAdminQuery} from '../../features/patientSlice'
import { resetDeviceSearch } from "../../redux/deviceSearchSlice"

export default function ViewDevice() {
    const navigate = useNavigate()
    const { isSideBar, setToastErrorMessage, setToastmessage,editSocket,sendMessageToStartEditing,setIsAdvancedSearchOpen} = useContext(GlobalContext)
    const location = useLocation();
    const dispatch=useDispatch()
    const [deleteDevice] = useDeleteDeviceMutation()
    const [devicetemplateInfo, setDevicetemplateInfo] = useState("");
    const [loading, setLoading] = useState(false)
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const dateformat = useSelector(state => state.systemConfigData.globalVariables.date_format)
    const messageSent = useSelector(state=>state?.systemConfigData?.messageSent)
      
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsadmin, setQueryParamsadmin] = useState('')
    const userType=localStorage?.getItem('user_type')!==null?localStorage.getItem('user_type'):sessionStorage.getItem('user_type')
      
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideAdminQuery(queryParamsadmin, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });
    
    
    
     useEffect(() => {
        if (userType === 'corporate-user') {
            setQueryParamsadmin('type=corporate-view-devices');
        } else {
            setQueryParamsadmin('type=admin-view-devices');
        }
    }, [userType]);
      
    useEffect(() => {
        if (queryParamsadmin) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsadmin]);

    const { id } = useParams()
    const { data, isFetching, status } = useViewDeviceQuery(id,{refetchOnMountOrArgChange:true});


    const handleDelete = async (e) => {
        setLoading(true);
        let body = {
            device_id: [devicetemplateInfo?.device_id]
           
        }
        
        const res = await deleteDevice(body)
    
        if (res?.error?.data?.message) {
            setToastErrorMessage(res?.error?.data?.message)
            setLoading(false)
        }
        else {
            setToastmessage('Device deleted successfully');
            setLoading(false)
            setDeleteModalOpen(false)
            navigate('/manage-devices')
        }
    }

    const handleConformationClick = () => {
        setDeleteModalOpen(false)
    }

    useEffect(() => {
        if (data !== undefined) {
            setDevicetemplateInfo(data)
        }
    }, [data])
 
    
    const initialtimestamp=(devicetemplateInfo?.initial_reading_timestamp===null || devicetemplateInfo?.initial_reading_timestamp==="" || devicetemplateInfo?.initial_reading_timestamp===undefined) ? "-" : convertEpochToDateFormat(devicetemplateInfo?.initial_reading_timestamp,dateformat)
    const assigned =(devicetemplateInfo?.assigned_at===null || devicetemplateInfo?.assigned_at==="" || devicetemplateInfo?.assigned_at===undefined) ? "-" : convertEpochToDateFormat(devicetemplateInfo?.assigned_at, dateformat);

    const handleDevicestatus = (key) => {
        let val = {}
       
        switch (devicetemplateInfo?.status) {
            case "active":
                val = { classKey: "bg-[#CCE7E7]  text-[#006A6B]", text : "Active"}
                break;
            case "out-of-service":
                val = { classKey: "bg-[#EEB9BC] text-[#C81720]" , text : "Out of Service"}
                break;
            case "retired":
                val = { classKey: "bg-[#C5C9DA]  text-[#52555D]", text : "Retired" }
                break;

            default:
                break;
        }
        return val[key];

    }

    const handleNavigationToEditPage = () => {
        if(!messageSent){
            sendMessageToStartEditing(devicetemplateInfo?.device_id)
            let message
            editSocket.onmessage = (event) =>{
                message = event.data
         
                if(JSON.parse(message)?.success_status===true && JSON.parse(message)?.message==='Success'){
                    navigate(`/manage-devices/edit-device/${id}`,{state:[location.state,true,id]})
                    setIsAdvancedSearchOpen(false);
                    dispatch(resetDeviceSearch());
                    
                    
                } else{
                    dispatch(handleEditMessageSent(false))
                    { (JSON.parse(message)?.adminId) &&
                        setToastErrorMessage(`A user with username ${decodeURIComponent( JSON.parse(message)?.adminId)} is already editing this device`)
                    }
                    
                }
            }    
        }
}

    return (
        <>
            <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
                <TopHeader title={"Manage Device"} />
                {isFetching && status !== "fulfilled" ? <CustomOverLay Active text="Loading Device Details..." classKey={`absolute top-0 left-0 z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar ? 'opened-sidebar-config' : 'system_config_overlay'}`} />:status==="rejected"?<SearchEmptyScreen text={"No data found"} />: <>

                    <div className='bg-white rounded-lg py-[12px] px-[30px] h-customh3'>
                        <motion.div
                            className="mt-1"
                            animate={{ x: 0 }}
                            initial={{ x: -10 }}
                            transition={{ duration: 0.5 }}
                        >
                            <div className='bg-white'>
                                <div className='flex items-center mb-5'>
                                    <Link to="/manage-devices" state={Array.isArray(location.state) ? '' : location.state}>
                                        <h1 className="text-sm font-normal text-[#52555D]">List of Device </h1>
                                    </Link>
                                    <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon" /></span>
                                    <h1 className="text-sm font-normal text-[#008586]">View Device</h1>
                                    {
                userType !=='super-admin' &&
                <span   onClick={() => setHelpGuideModel(true)} className='ml-auto min-w-fit cursor-pointer'>
                    <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                </span> 
            }
                                </div>

                                <div className="flex items-center justify-between">
                                    <button onClick={() => navigate(-1)} className='flex items-center min-w-max'>
                                        <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                                        <span className='text-sm font-normal text-[#008586] ml-3'>Go back to Listing</span>
                                    </button>
                                </div>
                                <h1 className='text-xl font-normal text-[#000000] w-full text-center mt-[-23px]'>View Device</h1>
                                <div className="pt-2 pb-2 w-full flex justify-end items-center">
                                    <div className="flex items-center">
                                        <button data-testid="edit-device"  onClick={() => { handleNavigationToEditPage()}} id="edit" type='button' className={'min-w-max px-4 py-1 border border-[#972E4C] h-fit rounded-[16px] flex items-center'}>
                                            <span className='w-5'><img src="/images/edit_icon.svg" alt="icon" /></span>
                                            <span className='pl-2.5 text-lg font-normal text-[#972E4C]'>Edit</span>
                                        </button>
                                        <button data-testid="edit-provider" onClick={() => setDeleteModalOpen(true)} id="delete" type='button' className='min-w-max px-4 hover:bg-[#E7EAF4] ml-2 py-2 h-fit rounded-[4px] flex items-center'>
                                            <span className='w-5'><img src="/images/deleteicon-pink.svg" alt="icon" /></span>
                                            <span className='pl-2.5 text-[16px] leading-normal font-normal text-[#000000]'>Delete</span>
                                        </button>
                                    </div>
                                </div>
                                <div className="h-customh1 border p-[24px] border-[#C5C9DA] overflow-auto scrollbar_gray scrollBar-hidden">
                                    <div className=" bg-[#E7EAF4] rounded-lg px-10 pt-[30px] pb-[22px]">
                                        <div>
                                            <div className="w-full flex justify-between">
                                                <div className="w-[25%]">
                                                    <div className=" mb-[30px] ">
                                                        {devicetemplateInfo?.image_url !== "" ?
                                                            <img className=" border-2 border-dashed border-[#972E4C] bg-white py-10 w-[350px] xl:h-[250px] h-[180px] rounded-[10px] px-4" src={`${CDN}${devicetemplateInfo?.image_url}`} alt="device-image" /> :
                                                            <div className='relative'>
                                                                <img className=" border-2 border-dashed border-[#972E4C] bg-white py-10 w-[350px] xl:h-[250px] h-[180px] rounded-[10px] px-4" src={'/images/empty-image.svg'} alt="device-image" />
                                                                <p className='absolute text-[12px] font-normal text-[#52555D] bottom-[15px] w-full text-center '>No Image Uploaded</p>
                                                            </div>}
                                                    </div>
                                                    <div className="w-full mb-[30px]">
                                                        <p className="text-sm font-normal text-[#000]">Patient ID</p>
                                                        <p data-testid="patient-id" className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                            {(devicetemplateInfo?.patient_id === "" || devicetemplateInfo?.patient_id === undefined ) ? '-' : devicetemplateInfo?.patient_id }</p>
                                                    </div>
                                                    <div className="w-full mb-[30px]">
                                                        <p className="text-sm font-normal text-[#000]">Assigned</p>
                                                        <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                            {assigned}</p>
                                                    </div>
                                                    <div className="w-full mb-[30px]">
                                                        <p className="text-sm font-normal text-[#000]">Initial Reading Timestamp</p>
                                                        <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                            {initialtimestamp}</p>
                                                    </div>

                                                </div>
                                                <div className="w-[75%]">
                                                    <div className="flex  mb-[30px]">
                                                        <div className="w-1/3 px-6">
                                                            <div className="w-full">
                                                                <p className="text-sm font-normal text-[#000]">Device Template</p>
                                                                <p className="text-base capitalize text-normal text-[#000B17] pt-2 break-words">
                                                                    {devicetemplateInfo?.device_template!== "" ? devicetemplateInfo?.device_template: '-'}</p>
                                                            </div>
                                                        </div>
                                                        <div className="w-1/3 px-6">
                                                            <div className="w-full">
                                                                <p className="text-sm font-normal text-[#000]">Device ID</p>
                                                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                    {devicetemplateInfo?.device_id !== "" ? devicetemplateInfo?.device_id : '-'}</p>
                                                            </div>
                                                        </div>
                                                        <div className="w-1/3 px-6">
                                                            <div className="w-full">
                                                                <p id="status" className={`text-sm rounded-[24px] ${handleDevicestatus("classKey")} py-1.5 px-3.5 w-fit font-semibold`}>
                                                                    {handleDevicestatus("text")}</p>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className="w-full px-6 mb-[30px]">
                                                        <p className="text-sm font-normal text-[#000]">Reading Type</p>
                                                        {devicetemplateInfo?.reading_type && devicetemplateInfo?.reading_type.length > 0 ?
                                                            <p className="text-base capitalize text-normal text-[#000B17] pt-2 break-words">
                                                                {/* {devicetemplateInfo.reading_type.join(', ')} */}
                                                                {[devicetemplateInfo?.reading_type] &&
                                                                typeof [devicetemplateInfo?.reading_type] === 'string'
                                                                ? [devicetemplateInfo?.reading_type].replace(/[_-]/g, " ")
                                                                : ([devicetemplateInfo?.reading_type ]|| '').toString().replace(/[_-]/g, " ")}
                                                            </p>
                                                            :
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                -
                                                            </p>
                                                        }
                                                    </div>
                                                    <div className="flex   mb-[30px]">
                                                        <div className="w-1/3 px-6">
                                                            <div className="w-full">
                                                                <p className="text-sm font-normal text-[#000]">Device Manufacturer </p>
                                                                <p className="text-base capitalize text-normal text-[#000B17] pt-2 break-words">
                                                                    {devicetemplateInfo?.manufacturer_name !== "" ? devicetemplateInfo?.manufacturer_name : '-'}</p>
                                                            </div>
                                                        </div>
                                                        <div className="w-1/3 px-6">
                                                            <div className="w-full">
                                                                <p className="text-sm font-normal text-[#000]">Model</p>
                                                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                    {devicetemplateInfo?.model !== "" ? devicetemplateInfo?.model : '-'}</p>
                                                            </div>
                                                        </div>
                                                        <div className="w-1/3 px-6">
                                                            <div className="w-full">
                                                                <p className="text-sm font-normal text-[#000]">Serial Number</p>
                                                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                    {devicetemplateInfo?.serial_number !== "" ? devicetemplateInfo?.serial_number : '-'}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="flex justify-between mb-[30px]">
                                                        <div className="w-1/3 px-6">
                                                            <div className="w-full">
                                                                <p className="text-sm font-normal text-[#000]">Warranty Period</p>
                                                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                    {devicetemplateInfo?.warranty_period !== "" ? devicetemplateInfo?.warranty_period : '-'}</p>
                                                            </div>
                                                        </div>
                                                        <div className="w-1/3 px-6">
                                                            <div className="w-full">
                                                                <p className="text-sm font-normal text-[#000]">Purchase Date</p>
                                                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                    {devicetemplateInfo?.purchase_date === "" ? '-' : moment(devicetemplateInfo?.purchase_date).format("MM/DD/YYYY")}</p>
                                                            </div>
                                                        </div>
                                                        <div className="w-1/3 px-6">
                                                            <div className="w-full">
                                                                <p className="text-sm font-normal text-[#000]">Original Location</p>
                                                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                    {devicetemplateInfo?.original_location !== "" ? devicetemplateInfo?.original_location : '-'}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="flex justify-between mb-[30px]">
                                                        <div className="w-1/3 px-6">
                                                            <div className="w-full">
                                                                <p className="text-sm font-normal text-[#000]">Service Provider</p>
                                                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                    {devicetemplateInfo?.service_provider !== "" ? devicetemplateInfo?.service_provider : '-'}</p>
                                                            </div>
                                                        </div>
                                                        <div className="w-1/3 px-6">
                                                            <div className="w-full">
                                                                <p className="text-sm font-normal text-[#000]">Service Period</p>
                                                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                    {devicetemplateInfo?.service_period !== "" ? devicetemplateInfo?.service_period : '-'}</p>
                                                            </div>
                                                        </div>
                                                        <div className="w-1/3 px-6">
                                                            <div className="w-full">
                                                                <p className="text-sm font-normal text-[#000]">Service Activation Date</p>
                                                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                    {devicetemplateInfo?.service_activation_date === "" ? '-' : moment(devicetemplateInfo?.service_activation_date).format("MM/DD/YYYY")}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="flex justify-between mb-[30px]">
                                                        <div className="w-1/3 px-6">
                                                            <div className="w-full">
                                                                <p className="text-sm font-normal text-[#000]">Api Identifier </p>
                                                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                    {devicetemplateInfo?.api_identifier !== "" ? devicetemplateInfo?.api_identifier : '-'}</p>
                                                            </div>
                                                        </div>
                                                        <div className="w-2/3 px-6 mb-[30px]">
                                                            <p className="text-sm font-normal text-[#000]">Description</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {devicetemplateInfo?.description !== "" ? devicetemplateInfo?.description : '-'}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    </div>
                </>}
                {deleteModalOpen &&
                    <AnimatedModel
                        Children={
                            <ConfirmationPrompt
                                handleOnCLickActivate={handleDelete}
                                handleClose={handleConformationClick}
                                tittle={'Delete'}
                                message={`Are you sure you want to delete this device?`}
                                buttonName={"Yes"}
                                loadingActivation={loading}
                                CancelButton={"No"}
                            />
                        }
                    />
                }
                {(helpGuideModel && helpguidestatus==="fulfilled") &&
                <HelpGuideModal
                    setHelpGuideModel={setHelpGuideModel}
                    pdfUrl={helpguidedata} // Pass the PDF URL to the modal
            />
            }
            </div>
        </>
    )
}